
import React from "react";
import {useScript} from "../../../utils/useScript";

const ZebraBrowserPrint =  () => {
   // const prt = useScript('./BrowserPrint-3.0.216.min.js', 'zebraPrinter');

    //console.log("zebraPrinter prt", prt);

    // prt.getDefaultDevice('printer', (prt) => {
    //     console.log("printer", prt);
    //     },
    //     (error) => {
    //       console.log("prt error",error);
    //     }
    // );



        let selectedPrinter = null;
    var format_start = "^XA^LL200^FO80,50^A0N36,36^FD";
    var format_end = "^FS^XZ";
    var default_mode = true;

    console.log('browserPrinter getDefault');


    return (
        <React.Fragment>
            <script>
            {/*    function xprint() {*/}
            {/*            BrowserPrint.getDefaultDevice('printer',*/}
            {/*                (printer) => {*/}
            {/*                    selectedPrinter = printer;*/}
            {/*                    console.log("browserprint printer", printer);*/}
            {/*                    //printer.send(format_start + 'TEXTOESCRITO' + format_end, null, null);*/}
            {/*                },*/}
            {/*                (error) => {*/}
            {/*                    console.log("BrowserPrint error", error);*/}
            {/*                }*/}
            {/*            )*/}
            {/*}*/}

            </script>


            <button onClick="xprint();" >Impressao</button>
            { <p>DRIVER CARREGADO COM SUCESSO You can use the script here.</p>}

        </React.Fragment>
    )

}

export default ZebraBrowserPrint;
